import React from 'react';
import { motion } from 'framer-motion';
import { Link2Icon, QrCodeIcon, KeyRoundIcon } from 'lucide-react';
import { PhoneFrame } from './PhoneFrame';
import { screens } from '../data/screens';
import { WEB_JOIN_URL } from '../data/launch';
const methods = [{
  icon: Link2Icon,
  label: 'A link',
  detail: 'Tap it, pick a name, done.'
}, {
  icon: QrCodeIcon,
  label: 'A QR code',
  detail: 'Point a camera at the screen.'
}, {
  icon: KeyRoundIcon,
  label: 'A join code',
  detail: 'Type the reference in.'
}];
export function WaysToJoin() {
  return <section id="ways-to-join" className="relative overflow-hidden bg-kitty-yellow py-20 lg:py-28" data-id="element-327" data-mp="2al5o837ron3e">
      <div className="mx-auto max-w-7xl px-6 sm:px-8" data-id="element-328" data-mp="2fg1f3019p4ex">
        <div className="grid items-center gap-14 lg:grid-cols-12 lg:gap-10" data-id="element-329" data-mp="2jippvd9jklej">
          {/* Screens */}
          <motion.div initial={{
          opacity: 0,
          y: 28
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55,
          ease: [0.22, 1, 0.36, 1]
        }} className="order-2 lg:order-1 lg:col-span-6" data-id="element-330" data-mp="l568225qdxe9">
            <div className="relative mx-auto w-full max-w-[320px] sm:max-w-[520px]" data-id="element-331" data-mp="1lmrbv4zwv4km">
              {/* The QR share screen, tucked behind */}
              <PhoneFrame screen={screens.shareQr} decorative className="absolute right-0 top-[14%] hidden w-[44%] rotate-[8deg] sm:block" data-id="element-332" data-mp="1brhb0kl9138f" />
              {/* The browser join, front and large */}
              <div className="relative z-10 w-full sm:w-[62%]" data-id="element-333" data-mp="24etuglw44uxi">
                <PhoneFrame screen={screens.webJoin} shadow="xl" data-id="element-334" data-mp="1zg0gytgtt3xc" />
              </div>
            </div>
          </motion.div>

          {/* Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5
        }} className="order-1 lg:order-2 lg:col-span-6" data-id="element-335" data-mp="1ug4fb0vlpoky">
            <p className="mb-4 text-sm font-black uppercase tracking-widest text-kitty-dark/60" data-id="element-336" data-mp="3787lkyfdz8kk">
              The bit other apps get wrong
            </p>
            <h2 className="mb-5 text-4xl font-black leading-[1.05] tracking-tight text-kitty-dark md:text-5xl lg:text-6xl" data-id="element-337" data-mp="2xa1jogtky2fp">
              No app?
              <br data-id="element-338" data-mp="326rxsyltqnyh" />
              No problem.
            </h2>
            <p className="mb-4 max-w-md text-lg font-medium leading-relaxed text-kitty-dark/80 lg:text-xl" data-id="element-339" data-mp="2njgjwq266rv7">
              Send a link, QR code or join code. Friends can join the kitty from
              their browser without downloading KittyPot.
            </p>
            <p className="mb-9 max-w-md text-lg font-bold text-kitty-dark" data-id="element-340" data-mp="2ji4t4h7k80lf">
              They choose their name and they're in.
            </p>

            <ul className="mb-9 grid gap-3 sm:grid-cols-3" data-id="element-341" data-mp="24lvxdpmvo5dr">
              {methods.map(method => <li key={method.label} className="rounded-2xl bg-white/70 p-4 backdrop-blur-sm" data-id="element-342" data-mp="29k759utm45tc">
                  <method.icon className="mb-2.5 h-5 w-5 text-kitty-dark" aria-hidden="true" data-id="element-343" data-mp="1pxdqg6a6v3yb" />
                  <p className="font-extrabold text-kitty-dark" data-id="element-344" data-mp="1lx25esdwz1mb">
                    {method.label}
                  </p>
                  <p className="mt-0.5 text-sm text-kitty-dark/70" data-id="element-345" data-mp="1zx4lqa6kpmzg">
                    {method.detail}
                  </p>
                </li>)}
            </ul>

            
          </motion.div>
        </div>
      </div>
    </section>;
}